var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-1",attrs:{"id":"app"}},[_c('div',{class:_vm.isMob ? 'transform-90' : 'wd-100p ht-100p'},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }